import React, { useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import { Button, TextField, Box, Typography, Tabs, Tab } from '@mui/material';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';

import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { getVendors } from './action.ts';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VendorsPage = () => {
    const [vendors, setVendors] = useState<any[]>([]);
    const [addVendorsModalOpen, setAddVendorsModalOpen] = useState(false);
    const [editVendorsModalOpen, setEditVendorsModalOpen] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    useEffect(() => {
        sessionStorage.removeItem('trips_active_tab');
        getVendors(
            userDetailsFromStorage?.user?.id,
            (response) => {
                if (response.status === 200) {
                    setVendors(response.message.vendors);
                } else {
                    toast.error("Failed to fetch vendors");
                }
            },
            (errorMessage) => {
                toast.error(errorMessage);
            }
        );
    }, []);

    const handleClickOpen = () => {
        setAddVendorsModalOpen(true);
    };
    const handleClickEditOpen = (vendor) => {
        setSelectedVendor(vendor);
        setEditVendorsModalOpen(true);
    };
    
    const handleCloseAdd = () => {
        setAddVendorsModalOpen(false);
    };
    const handleCloseEdit = () => {
        setEditVendorsModalOpen(false);
    };
    const rows = vendors.map((vendor, index) => ({
        id: vendor.id,
        slNo: index + 1,
        vendorName: vendor.name,
    }));

    const columns = [
        { field: 'slNo', headerName: 'SL No', width: 100, headerAlign: 'center' },
        { field: 'vendorName', headerName: 'Vendor Name', width: 200, headerAlign: 'center' },
        { field: 'contactName', headerName: 'Contact Name', width: 200, headerAlign: 'center' },

        { field: 'mobileNumber', headerName: 'Mobile Number', width: 200, headerAlign: 'center' },

        { field: 'location', headerName: 'Location', width: 200, headerAlign: 'center' },

        { field: 'email', headerName: 'Email', flex:1, headerAlign: 'center' },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 100, headerAlign:'center',
            renderCell: (params: GridRenderCellParams) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    gap: '8px',
                  }}
                >
             <IconButton color="primary" >
                        <DeleteIcon />
                      </IconButton>
                      <IconButton color="primary" onClick={() => handleClickEditOpen(params.row)}>
                        <EditIcon />
                    </IconButton>
            </div>
              );
            },
          }

    ];

    return (
        <>
            <Header />
            <div style={{ marginTop: "70px" }}>
                <Heading
                    title="Vendors"
                    closeIcon="false"
                    rightContent={
                         <Box display="flex" alignItems="center" gap="10px">
                            <Button
                                className="custom-button"
                                onClick={handleClickOpen}
                            >
                                Add Vendors
                            </Button>
                    </Box>
                    }
                />
                      <Box 
                          className="table-container custom-data-grid" 
                          sx={{ 
                              marginLeft: {
                                  xs: '10px', 
                                  sm: '180px', 
                              },
                              marginTop: '10px', 
                              marginRight: '40px', 
                              position: 'relative', 
                              height: '500px', 
                              overflowY: 'auto' 
                          }}
                      >
                      
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                autoHeight
                                disableExtendRowFullWidth={true}
                                disableRowSelectionOnClick
                                hideFooterPagination
                            />
                      
               </Box>
                {/* <AddVendorsModal open={addVendorsModalOpen} onClose={handleCloseAdd} />
                <EditVendorsModal 
                    open={editVendorsModalOpen} 
                    onClose={handleCloseEdit} 
                    vendor={selectedVendor} 
                /> */}

            </div>
            <NavBar selected="Vendors" />
        </>
    );
};

export default VendorsPage;
